import { useState } from 'react';

import { Button, SubmitButton } from '../../components';
import { Modal, Form, FormItem } from '../../components';
import { Input, Dropdown, Toggle } from '../../components';
import type { FormType } from './useCampaignActions';

type CampaignModalProps = {
  loading: boolean;
  initialValues?: FormType;

  onClose: () => void;
  onSumbit: (payload: FormType) => void;
};

const CampaignModal: React.FC<CampaignModalProps> = ({
  loading,
  initialValues,
  onClose,
  onSumbit,
}) => {
  const [values, setValues] = useState<FormType>(
    initialValues || { is_active: true }
  );

  return (
    <Form<FormType> initialValue={values} onChange={setValues}>
      <Modal
        open
        title={initialValues ? 'Edit Campaign' : 'Add Campaign'}
        onClose={onClose}
        headerActions={
          <>
            <SubmitButton
              type="primary"
              loading={loading}
              onClick={() => values && onSumbit?.(values)}
            >
              Save
            </SubmitButton>
            <Button onClick={onClose}>Cancel</Button>
          </>
        }
      >
        <div className="flex flex-col gap-y-md">
          <FormItem<FormType> label="Name" name="name" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="Description" name="description" required>
            <Input />
          </FormItem>
          <FormItem<FormType> label="Status" name="status" required>
            <Dropdown
              options={[
                { value: 'active', label: 'Active' },
                { value: 'inactive', label: 'Inactive' },
                { value: 'completed', label: 'Completed' },
              ]}
            />
          </FormItem>
          <FormItem<FormType> label="Active?" name="is_active" required>
            <Toggle />
          </FormItem>
        </div>
      </Modal>
    </Form>
  );
};

export default CampaignModal;
